export const documents = [
  // 📂 Documents d’état civil
  { nom: "Acte de naissance du bailleur", destinataire: "bailleur" },
  { nom: "Acte de naissance du locataire", destinataire: "locataire" },
  { nom: "Livret de famille (si lien matrimonial ou indivision)", destinataire: "commun" },

  // 📂 Documents d’identité
  { nom: "Justificatif d’identité du bailleur", destinataire: "bailleur" },
  { nom: "Justificatif d’identité du locataire", destinataire: "locataire" },

  // 📂 Documents de domicile
  { nom: "Justificatif de domicile du bailleur", destinataire: "bailleur" },
  { nom: "Justificatif de domicile du locataire", destinataire: "locataire" },

  // 📂 Documents relatifs au bien loué
  { nom: "Titre de propriété du bien", destinataire: "bailleur" },
  { nom: "Description du logement/local (surface, pièces, annexes)", destinataire: "commun" },
  { nom: "Relevé cadastral ou référence cadastrale", destinataire: "commun" },
  { nom: "Plans du bien (si disponibles)", destinataire: "commun" },

  // 📂 Diagnostics techniques
  { nom: "Diagnostic de performance énergétique (DPE)", destinataire: "bailleur" },
  { nom: "Constat de risque d’exposition au plomb (si immeuble ancien)", destinataire: "bailleur" },
  { nom: "État des risques et pollutions (ERP)", destinataire: "bailleur" },
  { nom: "Diagnostic électricité ou gaz (si installation > 15 ans)", destinataire: "bailleur" },
  { nom: "Diagnostic amiante (si immeuble ancien)", destinataire: "bailleur" },

  // 📂 Documents financiers
  { nom: "RIB du bailleur", destinataire: "bailleur" },
  { nom: "Justificatif de revenus du locataire (3 derniers bulletins de salaire ou équivalent)", destinataire: "locataire" },
  { nom: "Dernier avis d’imposition du locataire", destinataire: "locataire" },
  { nom: "Attestation d’employeur ou contrat de travail du locataire", destinataire: "locataire" },
  { nom: "Justificatif de ressources complémentaires (si applicables)", destinataire: "locataire" },

  // 📂 Garantie et caution
  { nom: "Acte de cautionnement (si caution)", destinataire: "commun" },
  { nom: "Justificatif d’identité de la caution (si applicable)", destinataire: "commun" },
  { nom: "Justificatif de domicile de la caution (si applicable)", destinataire: "commun" },
  { nom: "Justificatifs de revenus de la caution (si applicable)", destinataire: "commun" },

  // 📂 Documents contractuels
  { nom: "Projet de bail notarié", destinataire: "commun" },
  { nom: "État des lieux d’entrée", destinataire: "commun" },
  { nom: "Règlement de copropriété (si bien en copropriété)", destinataire: "commun" },
  { nom: "Attestation d’assurance habitation du locataire", destinataire: "locataire" },

  // 📂 Spécifiques bail professionnel ou commercial
  { nom: "Extrait Kbis ou justificatif d’activité du locataire professionnel", destinataire: "locataire" },
  { nom: "Déclaration d’activité ou statuts de société", destinataire: "locataire" },
  { nom: "Autorisation d’exploitation commerciale (si requise)", destinataire: "locataire" },

  // 📂 Documents fiscaux
  { nom: "Dernier avis de taxe foncière", destinataire: "bailleur" },

  // 📂 Documents complémentaires
  { nom: "Pouvoir ou procuration (si représentation)", destinataire: "commun" },
  { nom: "Convention particulière annexée au bail", destinataire: "commun" },
];